import { render, staticRenderFns } from "./FormularioPersonalidadJuridica.vue?vue&type=template&id=4358b96e&scoped=true&"
import script from "./FormularioPersonalidadJuridica.vue?vue&type=script&lang=ts&"
export * from "./FormularioPersonalidadJuridica.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioPersonalidadJuridica.vue?vue&type=style&index=0&id=4358b96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4358b96e",
  null
  
)

export default component.exports